<script>
    import {labels, mainTimeline, scenes} from "../timelines/main-timeline";
    import {onMount} from "svelte";
    import pageTitleInOut from "../animation-configs/pageTitleInOut";

    const labelKeys = Object.keys(labels);
    const sceneNames = scenes.map(({name}) => name);

    const text = [
        "",
        "",
        "",
        "Start the journey",
        "The customer searches for new ideas",
        "And begins to learn what’s out there",
        "They assemble their buying team",
        "And overcome the obstacles to success",
        "They draw up the shortlist",
        "And evaluate whether you are up to the job",
        "They want to know you can be trusted",
        "Finally, they pick the winning partner",
        "The new customer journey",
        "Where next?",
    ];

    onMount(() => {
        sceneNames.forEach((key, i) => {
            mainTimeline.from('.text' + i, pageTitleInOut, sceneNames[i] + 'Start');
            mainTimeline.to('.text' + i, pageTitleInOut, sceneNames[i] + 'End+=0.001');
        });
    })
</script>

<div class="page-title-container">
    {#each text as title, i}
        <h2 class={`title text${i}`}>{title}</h2>
    {/each}
</div>

<style>
    .page-title-container {
        z-index: 3;
        position: relative;
        width: 100%;
        top: 20px;
    }

    .title {
        position: relative;
        font-weight: 500;
        text-shadow: rgba(0,0,0,0.9) 0 0 40px;
        top: 0;
        height: 0;
        margin: 0;
        font-size: 50px;
        color: white;
        text-align: center;
        overflow: visible;
        letter-spacing: 1px;
    }

    @media (max-width: 639px) {
        .title {
            font-size: 30px;
            transform: translateY(-15px);
        }
    }

    @media screen and (max-height: 799px) {
        .page-title-container {
            transform: scale(0.8);
            transform-origin: top center;
        }
    }

    @media screen and (max-width: 1200px) {
        .page-title-container {
            transform: scale(0.8);
            transform-origin: top center;
        }
    }
</style>